import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["aria-label", "closeButton", "onHide", "className", "clsPrefix", "children", "renderCloseButton", "closeButtonProps"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { createChainedFunction } from '../../wui-core/src';
import { WebUI, prefix } from "../../wui-core/src/index.js";
var propTypes = {
  /**
   * 是否显示关闭按钮
   */
  closeButton: PropTypes.bool,

  /**
   * 关闭时的钩子函数
   */
  onHide: PropTypes.func,

  /**
   * 自定义关闭按钮的钩子函数
   */
  renderCloseButton: PropTypes.func,

  /**
   * 自定义关闭按钮的 props
   */
  closeButtonProps: PropTypes.object
};
var defaultProps = {
  'aria-label': 'Close',
  closeButton: false,
  clsPrefix: "".concat(prefix, "-modal-header")
};
var contextTypes = {
  $u_modal: PropTypes.shape({
    onHide: PropTypes.func
  })
};
var ModalHeader = (_dec = WebUI({
  name: "modal-header",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalHeader, _React$Component);

  var _super = _createSuper(ModalHeader);

  function ModalHeader() {
    _classCallCheck(this, ModalHeader);

    return _super.apply(this, arguments);
  }

  _createClass(ModalHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props['aria-label'],
          closeButton = _this$props.closeButton,
          onHide = _this$props.onHide,
          className = _this$props.className,
          clsPrefix = _this$props.clsPrefix,
          children = _this$props.children,
          renderCloseButton = _this$props.renderCloseButton,
          closeButtonProps = _this$props.closeButtonProps,
          props = _objectWithoutProperties(_this$props, _excluded);

      var modal = this.context.$u_modal;
      var classes = {};
      classes["".concat(clsPrefix)] = true;
      classes['dnd-handle'] = true;
      var closeBtnDom = /*#__PURE__*/React.createElement("button", _extends({}, closeButtonProps, {
        type: "button",
        className: "u-close dnd-cancel",
        "aria-label": label,
        onClick: createChainedFunction(modal.onHide, onHide)
      }), renderCloseButton ? renderCloseButton() : /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement("i", {
        className: "uf uf-close"
      })));
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: classNames(className, classes)
      }), closeButton && closeBtnDom, children);
    }
  }]);

  return ModalHeader;
}(React.Component)) || _class);
ModalHeader.propTypes = propTypes;
ModalHeader.contextTypes = contextTypes;
export default ModalHeader;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-modal/src/ModalHeader.js